import React from 'react'
import { Tab } from 'semantic-ui-react'
import BPSTS from './BPSTS';
import BPNonSTS from './BPNonSTS';
import BPTrash from '../../opd/_bp/BPTrash';

const panes = [
   { 
     menuItem: 'BP Belum STS', 
     render: () => <Tab.Pane attached={false}><BPNonSTS /></Tab.Pane> 
   },
   { 
      menuItem: 'BP Telah STS', 
      render: () => <Tab.Pane attached={false}><BPSTS /></Tab.Pane> 
   },
   {
     menuItem: 'BP Terhapus',
     render: () => <Tab.Pane attached={false}><BPTrash /></Tab.Pane>
   }
]

const BPIndex = () => (
  <Tab menu={{ pointing: true }} panes={panes} />
)

export default BPIndex;


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_bp/BPIndex.js